import { CopyIcon } from '@approvalmax/ui';
import { Button, Flex, Text } from '@approvalmax/ui/src/components';
import { memo, useCallback } from 'react';

import { messages } from './FundWalletCardField.messages';
import { FundWalletCardFieldProps } from './FundWalletCardField.types';

export const FundWalletCardField = memo<FundWalletCardFieldProps>((props) => {
    const { field, value, disabled = false, onCopy } = props;

    const handleClick = useCallback(() => {
        onCopy?.();
    }, [onCopy]);

    return (
        <Flex justifyContent='space-between' wrap={false} alignItems='start'>
            <Flex direction='column' spacing='4'>
                <Text font='label' fontSize='small' color='midnight70'>
                    {field}
                </Text>

                <Text font='label' fontSize='small' color='midnight100'>
                    {value}
                </Text>
            </Flex>

            <Button icon onClick={handleClick} disabled={disabled} title={messages.copy} variant='text' color='blue100'>
                <CopyIcon size='12' />
            </Button>
        </Flex>
    );
});

FundWalletCardField.displayName = 'FundWalletCard';
